/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Bulk_Review_EachInputs */



/**
* | output |
* | --- |
* | "Review each" |
*
* @param {Chat_Tool_Bulk_Review_EachInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_review_each = /** @type {((inputs?: Chat_Tool_Bulk_Review_EachInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Review_EachInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzeln prüfen")
	return /** @type {LocalizedString} */ ("Review each")
});